
(function ($, d, ns) {
    ns.initVintageToggler = function () {
        $('.js-vintage-toggle').on('click', function (e) {
            e.preventDefault();
            var linktext = 'HIDE VINTAGES';

            if ($(this).hasClass('active')) {
                linktext = 'SHOW VINTAGES';
            }

            $(this).children('.vintage-label').html(linktext);
            $(this).toggleClass('active');
            $('.js-vintage-row').toggleClass('active');
        });
    };

    $(d).ready(function () {
        ns.initVintageToggler();
    });


})(jQuery, document, Crafted.Utilities);